import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Form, Formik } from 'formik';
import { connect } from 'react-redux';
import * as homeActions from '../home/redux/actions';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { showAlertHtml } from '../../common/utils/alert';
import UploadCsv from './item/import/UploadCsv';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { CsvDataDisplay } from './CsvDataDisplay';

export class CollectionWithCsv extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    creationFailedMsg: '',
    isPersistent: true,
    fields: [],
    data: [],
    csvHeader: [],
    csvData: [],
    mappedFields: [],
    jsonConfig: {},
    isPopupOpen: false,
    collectionName: '',
  };

  handleOnDrop = (data, file) => {
    const { actions } = this.props;
    let csvHeader = data[0].meta.fields;
    const parts = file.name.split('.');
    const firstPart = parts[0];
    const correctname = firstPart.replace(/[^a-zA-Z]/g, '');
    const csvData = data.map((row) => row.data);
    this.setState({
      csvHeader,
      csvData,
      collectionName: correctname,
    });
    actions.toggleIsOpenCollectionCreateWithCsv();
  };
  setCollectionName = (value) => {
    this.setState({ collectionName: value });
  };
  updateJsonConfig = (value) => {
    this.setState({ jsonConfig: value });
  };
  handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  handleOnRemoveFile = (data) => {
    console.log(data);
  };
  handleFormSubmit = async (values) => {
    const { projectId, actions, version } = this.props;
    const data = {
      collectionTitle: this.state.collectionName,
      willPersist: this.state.isPersistent,
      fields: this.state.jsonConfig,
      projectId,
      version,
    };
    const createCollectionResponse = await actions.createCollectionWithCsv(data);
    await actions.loadProjectCollections({ projectId, version });
    if (createCollectionResponse && createCollectionResponse.data.uuid) {
      this.props.homeActions.loadEditorCollections({ projectId, version });
      const collectionId = createCollectionResponse.data.uuid;
      actions.loadProjectCollectionDetail({ projectId, collectionId, version });
      if (this.props.home && this.props.home.collections.length === 0) {
        this.props.projectOnBoardActions.changeProjectStatus({
          state: 'COLLECTION_CREATED',
          status: 'COMPLETE',
          projectId,
          version,
        });
      }
      const redirectPath = `/collections/${version}/v/${projectId}/edit/${collectionId}`;
      this.props.history.push(redirectPath);
      actions.toggleIsOpenCollectionCreateWithCsv();
      return;
    }

    //TODO: If failed then don't redirect and show error message
  };

  setCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'willPersist') {
      const confirmationMsg = checked
        ? `The DrapCode (default) database will be used to store and retrieve data.<br/><br/>Do you want to proceed?`
        : `Data will be fetched from an external source.<br/>Hence, you will <strong>not</strong> be able to store item data in the DrapCode (default) database.<br/><br/>Do you want to proceed?`;

      if (checked) {
        const preConfirm = () => {
          this.setState({ isPersistent: checked });
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      } else {
        const preConfirm = () => {
          this.setState({ isPersistent: checked });
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      }
    } else {
      this.setState({ [name]: checked });
    }
  };

  render() {
    const { creationFailedMsg, isPersistent, csvHeader, collectionName, jsonConfig } = this.state;
    const { collections, actions } = this.props;
    const typeDescription = `<ul style="padding-left:1rem"><li><strong>Persistent collection</strong> when <em>ON</em> will store item data in <em>DrapCode (default) database</em>.</li><li><strong>Persistent collection</strong> when <em>OFF</em> will not store any item data in <em>DrapCode (default) database</em>.</li></ul>`;

    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
          <i className={`wb ${drapcodeIcon('collection')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">
              Create Collection <span style={{ textTransform: 'none' }}>via</span> CSV
            </h4>
            <div className="card-cta"></div>
          </div>
          <Formik>
            {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-4">
                      {csvHeader.length > 0 && (
                        <Modal
                          isOpen={collections.isOpenCollectionCreateWithCsv}
                          toggle={() => {
                            actions.toggleIsOpenCollectionCreateWithCsv();
                          }}
                          backdrop="static"
                          style={{ maxWidth: '40%', marginTop: '70px' }}
                        >
                          <ModalHeader
                            toggle={() => {
                              actions.toggleIsOpenCollectionCreateWithCsv();
                            }}
                            className="border-bottom"
                          >
                            <strong>Create Collection via CSV</strong>
                          </ModalHeader>
                          <ModalBody>
                            <CsvDataDisplay
                              csvHeader={csvHeader}
                              onUpdateJsonConfig={this.updateJsonConfig}
                              collectionName={collectionName}
                              jsonConfig={jsonConfig}
                              setCollectionName={this.setCollectionName}
                              onSubmitForm={this.handleFormSubmit}
                              actions={actions}
                              isPersistent={isPersistent}
                              setCheckboxChange={this.setCheckboxChange}
                              typeDescription={typeDescription}
                              collections={this.props.collections}
                            />
                          </ModalBody>
                        </Modal>
                      )}
                      <UploadCsv
                        handleOnDrop={this.handleOnDrop}
                        handleOnError={this.handleOnError}
                        handleOnRemoveFile={this.handleOnRemoveFile}
                      />
                    </div>
                    {creationFailedMsg && (
                      <div className="error error-align">{creationFailedMsg}</div>
                    )}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionWithCsv);

